import { render, staticRenderFns } from "./change-route-form.vue?vue&type=template&id=0e7880e7&"
import script from "./change-route-form.vue?vue&type=script&lang=ts&"
export * from "./change-route-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports